import { Component, EventEmitter, Input, OnDestroy, Output, ChangeDetectionStrategy } from '@angular/core';
import { NgbActiveModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { DocumentActor } from 'src/app/models/actors';
import { BuilderRequestModel } from 'src/app/models/builder/builder-request.model';
;

export const dialogAddActionOptions: NgbModalOptions = {
  keyboard: false,
  centered: true,
  size: 'md',
  backdrop: 'static'
};
@Component({
    selector: 'app-dialog-add-action',
    templateUrl: './dialog-add-action.component.html',
    styleUrls: ['./dialog-add-action.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DialogAddActionComponent implements OnDestroy {

  @Input() action!: string;
  @Input() actors!: DocumentActor;
  @Input() request!: BuilderRequestModel;
  @Output() newAction: EventEmitter<any> = new EventEmitter<any>();

  selectedPersonIds: string[] = [];
  selectedPersonHasActions: boolean = false;

  constructor(private activeModal: NgbActiveModal) {
    // Must not be empty. It's approved by a comment.
  }
  ngOnDestroy(): void {
    this.selectedPersonIds = [];
  }

  close() {
    this.activeModal.close();
  }

  setSelectedPerson(event: string[]) {
    this.selectedPersonIds = event;
  }

  addAction() {
    this.newAction.emit({ personIds: this.selectedPersonIds });
  }
}
